;
/*!
 * subitotexto.courrier-submit.js
 */


SubitoTexto.courrierComments = {
	init      : function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierComments;

		// Also serves to check if we're in the right place.
		_this.$mainContainer = $( '.courrier-single' );


		if ( _this.$mainContainer.length < 1 ) {
			// Nothing to do on this page
			return;
		}


		if ( typeof CONFIG == 'undefined' || typeof CONFIG.courrier_comments_url == 'undefined' ) {
			console.error( '[SubitoTexto.courrierComments] Need the  CONFIG.courrier_submit_url  path' );
		}


		new Fingerprint2( {
			excludeAvailableScreenResolution: true,
			excludeScreenResolution         : true
		} ).get( function ( result, components ) {
			_this.fingerprint = result;
		} );


		// declare all our elements here...

		_this.$form = _this.$mainContainer.find( '.courrier-comment-form' );
		_this.$commentNameField = _this.$form.find( '#courrier-comment-name' );
		_this.$commentCommentField = _this.$form.find( '#courrier-comment-content' );

		_this.$commentsList = _this.$mainContainer.find( '.comments-list' );

		_this.$messageSuccess = _this.$mainContainer.find( '.message-success' );

		_this.bindEvents();
		_this.replaceEmojisClientSide();
		_this.prepFieldsForEmojiConversion();

	},
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierComments;


		_this.$form.on( 'submit', function ( e ) {
			e.preventDefault();

			//console.log( 'Trying to submit' );

			_this.processForm();
		} );
	},


	replaceEmojisClientSide: function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierComments;

		_this.$comments = _this.$commentsList.find( 'article' );


		if ( _this.$comments.length > 0 ) {

			_this.$comments.find( 'h3, div' ).each( function ( i, el ) {
				var $this = $( this ),
					htmlOriginal = $this.html(),
					convertedHtml = SubitoTexto.emoji.convertFromDb( htmlOriginal );

				// No use in doing this if there are no emoji
				if ( htmlOriginal != convertedHtml ) {
					$this.html( convertedHtml );
				}
			} );
		}
	},

	prepFieldsForEmojiConversion: function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierComments;

		_this.$commentNameField.on( 'keyup', function ( e ) {
			if ( typeof _this.$commentNameFieldEmojiPartner == 'undefined' ) {
				_this.$commentNameFieldEmojiPartner = _this.$form.find( '#' + _this.$commentNameField.data( 'emoji-partner' ) );
			}

			if ( _this.$commentNameFieldEmojiPartner.length > 0 ) {
				_this.$commentNameFieldEmojiPartner.val( SubitoTexto.emoji.prepForDb( _this.$commentNameField.val() ) );
			}
		} );


		_this.$commentCommentField.on( 'keyup', function ( e ) {
			if ( typeof _this.$commentCommentFieldEmojiPartner == 'undefined' ) {
				_this.$commentCommentFieldEmojiPartner = _this.$form.find( '#' + _this.$commentCommentField.data( 'emoji-partner' ) );
			}

			if ( _this.$commentCommentFieldEmojiPartner.length > 0 ) {
				_this.$commentCommentFieldEmojiPartner.val( SubitoTexto.emoji.prepForDb( _this.$commentCommentField.val() ) );
			}
		} );


		_this.$commentNameField.trigger( 'keyup' );
		_this.$commentCommentField.trigger( 'keyup' );
	},

	processForm: function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierComments;


		$.ajax( {
			url     : CONFIG.courrier_comments_url,
			dataType: 'json',
			type    : 'post',
			data    : _this.$form.serialize() + "&fingerprint=" + _this.fingerprint
		} )
			.done( function ( _data ) {

				if ( typeof _data.success == 'undefined' || _data.success != 1 ) {
					// problem

					SubitoTexto.form.processForm( _this.$form, _data.errors, true );

				} else {
					// success!

					_this.$form.add( _this.$mainContainer.find( '.courrier-comment-title' ) ).slideUp();

					_this.$messageSuccess.find( 'p' ).slideDown( function () {
						PLA.UTILS.scrollTop.scrollTo( _this.$messageSuccess, -40 );
					} );
				}

			} );

	}


};

